<template>
  <v-container>
    <v-row justify="center">
      <v-col class="text-center" cols="4" style="color: var(--v-people-base); font-weight: bold;">Selecione o tipo de cotação que deseja fazer:</v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" sm="3" md="3" lg="2" class="d-flex justify-center">
        <div class="d-flex flex-column align-center">
          <!-- <v-img class="hover11 figure" src="img/quote_home_pj.png" min-width="200" height="168" style="cursor: pointer;" @click="redirectToForm('PJ')" contain></v-img> -->
          <div @click="redirectToForm('PJ')" style="cursor: pointer; position: relative; height: 145px; max-height: 200px;">
            <ColoredSvgImg
              src="img/icons/building.svg"
              width="110"
              max-width="110"
              contain />

            <ColoredSvgImg
              src="img/icons/people.svg"
              :color1="$vuetify.theme.currentTheme.people"
              width="100"
              max-width="100"
              contain
              style="position: absolute; top: 112px; transform: translate(-50%, -50%); left: 50%;"
            />
          </div>
          <span
            class="people--text font-weight-bold">
            Pessoa Jurídica
          </span>
        </div>
      </v-col>
      <v-col cols="12" sm="3" md="3" lg="2">
        <!-- <v-img class="hover11 figure" src="img/quote_home_pj_plan.png" min-width="200" height="193" style="cursor: pointer;" @click="redirectToForm('PJ_PLAN')" contain></v-img> -->
         <div class="d-flex flex-column align-center">
          <div @click="redirectToForm('PJ_PLAN')" style="cursor: pointer; position: relative; height: 145px; max-height: 200px;">
            <ColoredSvgImg
              src="img/icons/building.svg"
              width="110"
              max-width="110"
              contain />

            <ColoredSvgImg
              src="img/icons/people-plan.svg"
              :color1="$vuetify.theme.currentTheme.people"
              width="100"
              max-width="100"
              contain
              style="position: absolute; top: 110px; transform: translate(-50%, -50%); left: 50%;"
            />
          </div>
          <span
            class="people--text font-weight-bold">
            Pessoa Jurídica
          </span>
          <span
            class="people--text font-weight-bold">
            Categoria do Plano
          </span>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapMutations} from "vuex";
import QuoteService from "@/services/odoo/QuoteService";
import XippAuthService from "@/services/auth/XippAuthService";
import ColoredSvgImg from "../../components/structure/coloredSvgImg.vue";

export default {
  components: {
    ColoredSvgImg,
  },
  data: () => ({
    quoteSessionkey: 'quoteDataObj',
    routeQuery: null
  }),
  methods: {
    ...mapMutations(['showmsg', 'setDialogLoading']),
    async redirectToForm(type) {
      let customQuery = null;
      
      if(this.routeQuery) {
        customQuery = {
          ...this.routeQuery,
        }
      }
      customQuery.type = type;

      await this.onClickEditOrDetail(type);
      this.$forceUpdate();
      
      this.showmsg({
        text: 'O sistema foi aberto em uma nova aba do seu navegador.' +
          '<br/>Caso haja algum bloqueador de pop-up habilitado, desabilite-o para poder utilizar o sistema.', 
        type: 'warning'
      });
      
      const routeData = this.$router.resolve({ name: 'quote-form', query: customQuery});
      window.open(routeData.href, '_blank');
    },
    async onClickEditOrDetail(type) {
      this.setDialogLoading(true);

      sessionStorage.removeItem(this.quoteSessionkey);
      if(this.$route.query.id) {

        let quoteData = null;
        
        if(!this.$route.query.cnpj) {
          await this._quoteService.detail(this.$route.query.id)
            .then((response) => {
              if (response && response.data) {
                quoteData = response.data;
              }
            })
            .catch((error) => {
              this.setDialogLoading(false);
              if (error && error.response && error.response.status === 400) {
                this.showmsg({text: error.response.data.message, type: 'error'})
              } else {
                this.showmsg({text: 'Ocorreu um erro ao tentar detalhar a cotação.', type: 'error'})
              }
            });
        }

        if(quoteData) {
          if(quoteData.type == type){
            const parentQuoteId = quoteData && quoteData.id ? quoteData.id : this.$route.query.id;
  
            const juridicalPersonObj = {
              cnpj: quoteData && quoteData.lead ? quoteData.lead.cnpj : null,
              legalName: quoteData && quoteData.lead ? quoteData.lead.commercialName : null,
              nameContact: quoteData && quoteData.lead && quoteData.lead.contact ? quoteData.lead.contact.name : null,
              phoneContact: quoteData && quoteData.lead && quoteData.lead.contact ? quoteData.lead.contact.mobilePhone : null,
              emailContact: quoteData && quoteData.lead && quoteData.lead.contact ? quoteData.lead.contact.email : null,
              emailWithCopy: quoteData && quoteData.lead && quoteData.lead.contact ? quoteData.lead.contact.emailCC : null,
              city: quoteData && quoteData.lead && quoteData.lead.city ? {
                id: quoteData.lead.city.id,
                name: quoteData.lead.city.name,
                state_id: {
                  id: quoteData.lead.city.state ? quoteData.lead.city.state.id : null,
                  name: quoteData.lead.city.state ? quoteData.lead.city.state.name : null,
                  code: quoteData && quoteData.lead && quoteData.lead.city && quoteData.lead.city.state ? quoteData.lead.city.state.code : null,
                }
              } : null,
            }
  
            const planFiltersObj = {
              accommodations: quoteData && quoteData.contractFeatures && quoteData.contractFeatures.accommodation && quoteData.contractFeatures.accommodation.length
                ? quoteData.contractFeatures.accommodation.map(item => item.code) : [],
              allEmployees: quoteData && quoteData.contractFeatures ? [quoteData.contractFeatures.allEmployees] : [],
              geographicScopes: quoteData && quoteData.contractFeatures && quoteData.contractFeatures.geographicScope && quoteData.contractFeatures.geographicScope.length
                ? quoteData.contractFeatures.geographicScope.map(item => item.name) : [],
              hasCopay: quoteData && quoteData.contractFeatures ? [quoteData.contractFeatures.withCopay] : [],
              planClassifications: quoteData && quoteData.contractFeatures && quoteData.contractFeatures.classification && quoteData.contractFeatures.classification.length
                ? quoteData.contractFeatures.classification.map(item => item.id ? item.id.toString() : null) : [],
              hospitalsObj: quoteData && quoteData.contractFeatures && quoteData.contractFeatures.hospitalProviders && quoteData.contractFeatures.hospitalProviders.length
                ? quoteData.contractFeatures.hospitalProviders.map(item => item.id) : [],
              laboratoriesObj: quoteData && quoteData.contractFeatures && quoteData.contractFeatures.laboratoryProviders && quoteData.contractFeatures.laboratoryProviders.length
                ? quoteData.contractFeatures.laboratoryProviders.map(item => item.id) : [],
            }
  
  
            let benefitsObj = quoteData && quoteData.benefit ? quoteData.benefit : [];
            if (benefitsObj && benefitsObj.length) {
              benefitsObj.forEach(benefit => {
                benefit.carriers.forEach(carrier => {
                  const selectedPlans = carrier.selectedPlans;
                  carrier.planClassifications.forEach(planClassification => {
                    planClassification.plans.forEach(plan => {
                      if (selectedPlans && selectedPlans.length && selectedPlans.some(selectedPlan => parseInt(selectedPlan.id) === parseInt(plan.id))) {
                        plan.selected = true;
                      }
                    });
                  });
                });
              });
            }
  
            let ageIntervalsObj = [];
            let enumeratedAgesObj = [];
            let plansGroupByBenefitCarrierObj = [];
            if (quoteData && quoteData.type && quoteData.type === 'PJ') {
              ageIntervalsObj = quoteData && quoteData.ageRange ? quoteData.ageRange : [];
              enumeratedAgesObj = ageIntervalsObj[ageIntervalsObj.length - 1].beneficiariesFiftyNinePlus ?
                ageIntervalsObj[ageIntervalsObj.length - 1].beneficiariesFiftyNinePlus : [];
            } else if (quoteData && quoteData.type && quoteData.type === 'PJ_PLAN') {
              ageIntervalsObj = quoteData && quoteData.ageRange ? quoteData.ageRange : [];
              plansGroupByBenefitCarrierObj = this.groupPlansByBenefitCarrier(benefitsObj);
            }
  
            if (ageIntervalsObj && ageIntervalsObj.length) {
              ageIntervalsObj.forEach(item => {
                delete item.beneficiariesFiftyNinePlus;
              })
            }
  
            const projectObj = {id: null};
            if (quoteData && quoteData.studyConfigurationId) {
              projectObj.id = parseInt(quoteData.studyConfigurationId);
            }
  
            const quoteDataSession = {
              parentQuoteId,
              juridicalPersonObj,
              planFiltersObj,
              ageIntervalsObj,
              enumeratedAgesObj,
              benefitsObj,
              plansGroupByBenefitCarrierObj,
              projectObj
            }
  
            sessionStorage.setItem(this.quoteSessionkey, btoa(JSON.stringify(quoteDataSession)));
          } else {
            const parentQuoteId = quoteData && quoteData.id ? quoteData.id : this.$route.query.id;

            const juridicalPersonObj = {
              cnpj: quoteData && quoteData.lead ? quoteData.lead.cnpj : null,
              legalName: quoteData && quoteData.lead ? quoteData.lead.commercialName : null,
              nameContact: quoteData && quoteData.lead && quoteData.lead.contact ? quoteData.lead.contact.name : null,
              phoneContact: quoteData && quoteData.lead && quoteData.lead.contact ? quoteData.lead.contact.mobilePhone : null,
              emailContact: quoteData && quoteData.lead && quoteData.lead.contact ? quoteData.lead.contact.email : null,
              emailWithCopy: quoteData && quoteData.lead && quoteData.lead.contact ? quoteData.lead.contact.emailCC : null,
              city: quoteData && quoteData.lead && quoteData.lead.city ? {
                id: quoteData.lead.city.id,
                name: quoteData.lead.city.name,
                state_id: {
                  id: quoteData.lead.city.state ? quoteData.lead.city.state.id : null,
                  name: quoteData.lead.city.state ? quoteData.lead.city.state.name : null,
                  code: quoteData && quoteData.lead && quoteData.lead.city && quoteData.lead.city.state ? quoteData.lead.city.state.code : null,
                }
              } : null,
            }

            const quoteDataSession = {
              parentQuoteId,
              juridicalPersonObj
            }

            sessionStorage.setItem(this.quoteSessionkey, btoa(JSON.stringify(quoteDataSession)));
          }
        }
      }
      this.setDialogLoading(false);
    },
    groupPlansByBenefitCarrier(benefits) {
      let plansGroupByBenefitCarrier = [];
      const sumTotals = {
        ageIntervalsSum: [
          { description: '0 a 18', sum: null },
          { description: '19 a 23', sum: null },
          { description: '24 a 28', sum: null },
          { description: '29 a 33', sum: null },
          { description: '34 a 38', sum: null },
          { description: '39 a 43', sum: null },
          { description: '44 a 48', sum: null },
          { description: '49 a 53', sum: null },
          { description: '54 a 58', sum: null },
          { description: '59 ou +', sum: null },
        ],
        total: null,
      };

      const initialAgeIntervals = [
        { description: '0 a 18', holderCount: null, dependentCount: null, total: null },
        { description: '19 a 23', holderCount: null, dependentCount: null, total: null },
        { description: '24 a 28', holderCount: null, dependentCount: null, total: null },
        { description: '29 a 33', holderCount: null, dependentCount: null, total: null },
        { description: '34 a 38', holderCount: null, dependentCount: null, total: null },
        { description: '39 a 43', holderCount: null, dependentCount: null, total: null },
        { description: '44 a 48', holderCount: null, dependentCount: null, total: null },
        { description: '49 a 53', holderCount: null, dependentCount: null, total: null },
        { description: '54 a 58', holderCount: null, dependentCount: null, total: null },
        { description: '59 ou +', holderCount: null, dependentCount: null, total: null },
      ];

      if(benefits && benefits.length) {
        benefits.forEach(benefitItem => {
          benefitItem.carriers.forEach(carrierItem => {
            carrierItem.planClassifications.forEach(planClassification => {
              planClassification.plans.forEach(planItem => {
                const planSelectedFound = carrierItem.selectedPlans.find(selectedPlan => parseInt(selectedPlan.id) === parseInt(planItem.id));

                if(planSelectedFound) {
                  const benefitCarrier = {
                    benefitId: benefitItem.id,
                    benefitName: benefitItem.name,
                    benefitCode: benefitItem.code,
                    carrierId: carrierItem.id,
                    carrierName: carrierItem.name,
                    carrierDirectoryKit: carrierItem.directoryKit,
                    carrierComercialName: carrierItem.comercialName,
                    carrierImage: carrierItem.image,
                    carrierIsReference: carrierItem.isReference,
                    plans: [],
                    sumTotals: JSON.parse(JSON.stringify(sumTotals)),
                  }

                  const plan = {
                    id: planItem.id,
                    name: planItem.name,
                    ageIntervals: planSelectedFound ? planSelectedFound.ageRange : initialAgeIntervals,
                    ageIntervalsTotal: {
                      sumHolderCount: null,
                      sumDependentCount: null,
                      sumTotal: null,
                    },
                  };

                  const benefitCarrierFound = plansGroupByBenefitCarrier.find(benefitCarrier =>
                    benefitCarrier.benefitId === benefitItem.id && benefitCarrier.carrierId === carrierItem.id);
                  if(benefitCarrierFound) {
                    const indexOfBenefitCarrier = plansGroupByBenefitCarrier.indexOf(benefitCarrierFound);
                    const planFound = benefitCarrierFound.plans.find(plan => plan.id === planItem.id);

                    if(planFound) {
                      const indexOfPlan = benefitCarrierFound.plans.indexOf(planFound);
                      plansGroupByBenefitCarrier[indexOfBenefitCarrier].plans.splice(indexOfPlan, 1);

                      if(!plansGroupByBenefitCarrier[indexOfBenefitCarrier].plans.length) {
                        plansGroupByBenefitCarrier.splice(indexOfBenefitCarrier, 1);
                      }

                    } else {
                      plansGroupByBenefitCarrier[indexOfBenefitCarrier].plans.push(plan);
                    }
                  } else {
                    benefitCarrier.plans.push(plan);
                    plansGroupByBenefitCarrier.push(benefitCarrier);
                  }
                }
              });
            });
          });
        });
      }
      return plansGroupByBenefitCarrier;
    },
    async loadJWTToken() {
      if(this.$route.query && this.$route.query.token) {
        const sessionKey = "access_token";

        localStorage.setItem(sessionKey, this.$route.query.token);
        this.loadingToken = true;
        this.setDialogLoading(this.loadingToken);

        await this._xippAuthService.GetTokenFull()
          .then((response) => {
            if(response && response.data) {
              localStorage.setItem(sessionKey, response.data.token);
            }
          })
          .finally(() => {
            this.loadingToken = false;
            this.setDialogLoading(this.loadingToken);
          });
      }
    }
  },
  computed: {
  },
  async created() {
    this._quoteService = new QuoteService();
    this._xippAuthService = new XippAuthService();
    this.routeQuery = this.$route.query;

    await this.loadJWTToken();
    
    if (sessionStorage.getItem(this.quoteSessionkey)) {
      sessionStorage.removeItem(this.quoteSessionkey);
    }
    
    if(this.$route.params.incorrectType && this.$route.params.incorrectType === 'true') {
      this.showmsg({text: 'A opção de Pessoa Jurídica selecionada não é válida.<br> Por favor, escolha uma das opções a seguir.', type: 'error', route: 'home'});
    }

    if (this.$route.query.token) {
      //localStorage.setItem("access_token", this.$route.query.token);
      sessionStorage.removeItem("current_addfields");
      sessionStorage.removeItem("current_quote");
      sessionStorage.removeItem("user_current");
    }
  },
};
</script>

<style scoped>

.hover11:hover {
  opacity: .75;
}

</style>
